import { observer } from 'mobx-react';
import * as React from 'react';
import { SpeechData } from '../stores';
import { Speaker } from './Speaker';
import styles from './Speech.styl';

@observer
export class Speakers extends React.Component<{ data: SpeechData }> {
    render() {
        const { speakers } = this.props.data;
        return (
            <div className={styles.speakers}>
                {speakers.map(speaker => (
                    <Speaker key={speaker.name} speaker={speaker} />
                ))}
            </div>
        );
    }
}
